import AbstractShape, {Dimensions, DimensionProperties} from "./AbstractShape";
import Length from "../../../../source/js/shared/models/Geometry/Length";
import DimensionLine from "../Lines/DimensionLine";

/**
 * Class used as a safe fallback in case a shape hasn't yet been properly created
 * due to unforseen reasons (i.e. wanted font isn't  loaded, modifier is missing etc).
 */
export class Fallback extends AbstractShape {
	constructor( dimensions?: object ) {
		super( 'fallback', {} );

		this.labelMappings = {};
	}

	getLength(): Length {
		return this.cleanedPrimitives.length;
	}

	getWidth(): Length {
		return this.cleanedPrimitives.width;
	}

	getHeight(): Length {
		return this.cleanedPrimitives.height;
	}

	getDimensionProperties(): DimensionProperties {
		return { primary: 'width', secondary: 'length' };
	}

	getDimensionLines(ratio = 1, focusedElement = '', forceRender = false): DimensionLine[] {
		return [];
	}

	getDefaultDimensions(): Dimensions {
		return {
			width: 1,
			length: 1,
		};
	}

	getDefaultCutoutDimensions(parentShape: AbstractShape): Dimensions {
		return {
			width: 0,
			length: 0,
		};
	}
}
